const senders = 'Senders';

export const FETCH_SENDERS_REQUEST = `${senders}/FETCH_SENDERS_REQUEST` as const;
export const FETCH_SENDERS_RESPONSE = `${senders}/FETCH_SENDERS_RESPONSE` as const;
export const FETCH_SENDERS_ERROR = `${senders}/FETCH_SENDERS_ERROR` as const;

export const SET_DEFAULT_SENDER_REQUEST = `${senders}/SET_DEFAULT_SENDER` as const;

export const CREATE_SENDER_REQUEST = `${senders}/CREATE_SENDER_REQUEST` as const;

export const EDIT_SENDER_REQUEST = `${senders}/EDIT_SENDER_REQUEST` as const;

export const DELETE_SENDER_REQUEST = `${senders}/DELETE_SENDER_REQUEST` as const;
